import React, { useEffect, useState } from "react";
import { Formik, Field } from "formik";
import { Card, Button, Form, Row, Col } from "react-bootstrap";

import * as Yup from "yup";


import {
  Input,
  ModalProgressBar,
} from "../../../../../../../_metronic/_partials/controls";
import { Switch } from "@material-ui/core";

// Validation schema
const NetworkEditSchema = Yup.object().shape({
    appId: Yup.string()
      .min(1, "Minimum 1 symbol")
      .required("Placement ID is required"),
    appToken: Yup.string()
    .min(1, "Minimum 1 symbol")
    .required("Security Hash is required"),
    postbackSecret: Yup.string().required("Postback Secret is required"),
    provision: Yup.number()
      .min(0, "Minimum 0")
      .max(1, "maximum 1")
      .required("Provision is required"),
  });


function BitlabsOwForm({
    saveNetwork,
    network,
    actionsLoading,
    history,
  }) {
    const [check, setChecked] = useState(false);
  const [check1, setChecked1] = useState(false);

  const backToNetworkList = () => {
    history.push(`/dash/network`);
  };

  useEffect(() => {
    network.androidEnable === 0 ? setChecked(false) : setChecked(true);
    network.iosEnable === 0 ? setChecked1(false) : setChecked1(true);
  }, [network]);

  return (
    <>
      {actionsLoading && <ModalProgressBar />}
      <Card.Body>
        <Formik
          enableReinitialize={true}
          initialValues={network}
          validationSchema={NetworkEditSchema}
          onSubmit={(values) => {
            saveNetwork(values);
          }}
        >
          {({ handleSubmit, setFieldValue }) => (
            <>
              <Form>
                <Row>
                  <Col>
                    <Field
                      name="appId"
                      component={Input}
                      placeholder="App Token"
                      label="App Token"
                    />
                  </Col>
                  <Col>
                    <Field
                      type="text"
                      name="appToken"
                      component={Input}
                      placeholder="Secret Key"
                      label="Secret Key"
                    />
                  </Col>
                </Row>
                &nbsp;
                <Row>
                <Col>
                  <Field
                      name="provision"
                      component={Input}
                      placeholder="Provision"
                      label="Provision"
                      type="number"
                      step="0.1"
                    />
                  </Col>
                  <Col>
                    <Field
                      type="text"
                      name="postbackSecret"
                      component={Input}
                      placeholder="Posback Secret"
                      label="Posback Secret"
                    />
                  </Col>
                </Row>
                &nbsp;
                <Row>
                  <Col>
                    <div style={{ display: "flex" }}>
                      <label style={{ padding: "10px" }} htmlFor="switch">
                        Enable for Android:
                      </label>
                      <Switch
                        checked={check}
                        onChange={(e) => {
                          setChecked(e.target.checked);
                          let x;
                          e.target.checked ? (x = 1) : (x = 0);
                          setFieldValue("androidEnable", x);
                        }}
                        value="check"
                        inputProps={{ "aria-label": "primary checkbox" }}
                      />
                    </div>
                  </Col>
                  <Col>
                    <div style={{ display: "flex" }}>
                      <label style={{ padding: "10px" }} htmlFor="switch">
                        Enable for IOS:
                      </label>
                      <Switch
                        checked={check1}
                        onChange={(e) => {
                          setChecked1(e.target.checked);
                          let x;
                          e.target.checked ? (x = 1) : (x = 0);
                          setFieldValue("iosEnable", x);
                        }}
                        value="check1"
                        inputProps={{ "aria-label": "primary checkbox" }}
                      />
                    </div>
                  </Col>
                </Row>
                &nbsp;
              </Form>
              <>
                <Button
                  variant="primary"
                  type="submit"
                  onClick={() => handleSubmit()}
                >
                  Save
                </Button>
                <Button onClick={backToNetworkList} variant="secondry">
                  Cancel
                </Button>
              </>
            </>
          )}
        </Formik>
      </Card.Body>
      <Card.Footer>
        <h5>Postback:</h5>
        <p>
          {process.env.REACT_APP_API_POSTBACK+"/postback/bitlabs?status={status}&trans_id=[%TX%]&userid=[%UID%]&offerName=[%NET%]&amount_local=[%VAL%]&amount_usd=[%RAW%]&postbackkey={secret}&hash=[Hash]"}
        </p>
        <p>status is : 0 for Survey Reversals and 1 for Completed Survey</p>
        <p>secret is : your postaback secret</p>
      </Card.Footer>
    </>
  );
}

export default BitlabsOwForm;